<template>

    <div v-if="props.service" class="row">
        <div v-for="item in datas" :key="item" class="col-xl-3 col-lg-4 col-md-6 col-12 mb-5 ">
            <div class="card features feature-primary border-0">
                <div class="icon text-center rounded-md">
                    <i :class="item.icon"></i>
                </div>
                <div class="card-body p-0 mt-3">
                    <a href="#" class="title text-dark h5">{{item.name}}</a>
                    <p class="text-muted mt-3">{{item.desc}}</p>
                    <a href="#" class="link">Read More <i class="ri-arrow-right-line align-middle"></i></a>
                </div>
            </div>
        </div><!--end col-->
    </div><!--end row-->

    <div v-else class="container mt-100 mt-60">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="section-title mb-4 pb-2 text-center">
                    <span class="badge rounded-pill bg-soft-primary mb-3">Departments</span>
                    <h4 class="title mb-4">Our Medical Services</h4>
                    <p class="text-muted mx-auto para-desc mb-0">Great doctor if you need your family member to get
                        effective immediate assistance, emergency treatment or a simple consultation.</p>
                </div>
            </div><!--end col-->
        </div><!--end row-->

        <div class="row">
            <div v-for="item in datas.slice(0, 8)" :key="item" class="col-xl-3 col-md-4 col-12 mt-5">
                <div class="card features feature-primary border-0">
                    <div class="icon text-center rounded-md">
                        <i :class="item.icon"></i>
                    </div>
                    <div class="card-body p-0 mt-3">
                        <router-link to="/departments" class="title text-dark h5">{{ item.name }}</router-link>
                        <p class="text-muted mt-3">{{ item.desc }}</p>
                        <router-link to="/departments" class="link">Read More <i
                                class="ri-arrow-right-line align-middle"></i></router-link>
                    </div>
                </div>
            </div><!--end col-->
        </div><!--end row-->
    </div><!--end container-->
</template>

<script setup>
import { ref, defineProps } from 'vue';

const props = defineProps({
    service: {
        type: Boolean,
        required: true
    }
})
const datas = ref([
    {
        icon: 'ri-eye-fill h3 mb-0',
        name: 'Eye Care',
        desc: 'There is now an abundance of readable dummy texts required purely to fill a space.'
    },
    {
        icon: 'ri-psychotherapy-fill h3 mb-0',
        name: 'Psychotherapy',
        desc: 'There is now an abundance of readable dummy texts required purely to fill a space.'
    },
    {
        icon: 'ri-stethoscope-fill h3 mb-0',
        name: 'Primary Care',
        desc: 'There is now an abundance of readable dummy texts required purely to fill a space.'
    },
    {
        icon: 'ri-capsule-fill h3 mb-0',
        name: 'Dental Care',
        desc: 'There is now an abundance of readable dummy texts required purely to fill a space.'
    },
    {
        icon: 'ri-microscope-fill h3 mb-0',
        name: 'Orthopedic',
        desc: 'There is now an abundance of readable dummy texts required purely to fill a space.'
    },
    {
        icon: 'ri-pulse-fill h3 mb-0',
        name: 'Cardiology',
        desc: 'There is now an abundance of readable dummy texts required purely to fill a space.'
    },
    {
        icon: 'ri-empathize-fill h3 mb-0',
        name: 'Gynecology',
        desc: 'There is now an abundance of readable dummy texts required purely to fill a space.'
    },
    {
        icon: 'ri-mind-map h3 mb-0',
        name: 'Neurology',
        desc: 'There is now an abundance of readable dummy texts required purely to fill a space.'
    },
    {
        icon: 'ri-mental-health-line h3 mb-0',
        name: 'Dermatologists',
        desc: 'There is now an abundance of readable dummy texts required purely to fill a space.'
    },
    {
        icon: 'ri-apple-line h3 mb-0',
        name: 'Nutritionists',
        desc: 'There is now an abundance of readable dummy texts required purely to fill a space.'
    },
    {
        icon: 'ri-infrared-thermometer-line h3 mb-0',
        name: 'Physical Therapists',
        desc: 'There is now an abundance of readable dummy texts required purely to fill a space.'
    },
])

</script>

<style lang="scss" scoped></style>